const color = '#8A8E92';

type Props = {
  width?: number;
  height?: number;
};

const Typing = ({ width = 60, height = 40 }: Props) => (
  <svg
    x="0px"
    y="0px"
    style={{ margin: '-12px 0' }}
    width={width}
    height={height}
    viewBox="0 0 60 60"
    enableBackground="new 0 0 0 0"
    xmlSpace="preserve"
  >
    <circle
      fill={color}
      stroke="none"
      cx="6"
      cy="30"
      r="6"
    >
      <animateTransform
        attributeName="transform"
        dur="1s"
        type="translate"
        values="0 10; 0 -10; 0 10"
        repeatCount="indefinite"
        begin="0.1"
      />
    </circle>
    <circle
      fill={color}
      stroke="none"
      cx="30"
      cy="30"
      r="6"
    >
      <animateTransform
        attributeName="transform"
        dur="1s"
        type="translate"
        values="0 10; 0 -10; 0 10"
        repeatCount="indefinite"
        begin="0.2"
      />
    </circle>
    <circle
      fill={color}
      stroke="none"
      cx="54"
      cy="30"
      r="6"
    >
      <animateTransform
        attributeName="transform"
        dur="1s"
        type="translate"
        values="0 10; 0 -10; 0 10"
        repeatCount="indefinite"
        begin="0.3"
      />
    </circle>
  </svg>
);

export default Typing;
